import { render, staticRenderFns } from "./ArbitrationApply.vue?vue&type=template&id=5f47893f&scoped=true&"
import script from "./ArbitrationApply.vue?vue&type=script&lang=js&"
export * from "./ArbitrationApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f47893f",
  null
  
)

export default component.exports